import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';

import { currentPath, MEETUPS_TAG_SLUG } from './utils/routeState';

/**
 * La mitad de cliente del muro de `/t/encuentros` (PKG-FORO-PRODUCT-GATES · decisión B).
 *
 * POR QUÉ HACEN FALTA LAS DOS MITADES. `Forum\MeetupsFeedLoginWall` atiende las peticiones de
 * DOCUMENTO: escribir la URL, un enlace de fuera, un buscador. Pero dentro de la SPA ya
 * arrancada, un clic en la etiqueta «Encuentros» del panel lateral es un `Link` de Mithril:
 * `pushState` y a pintar, sin una sola petición al servidor. El middleware nunca corre, y el
 * invitado se colaba en el feed por la puerta del cliente — con la barra de direcciones
 * diciendo `/t/encuentros` y sin que hubiera habido muro.
 *
 * QUÉ ES ESTO Y QUÉ NO ES. Es una puerta de PRODUCTO, no un control de acceso. La etiqueta
 * `encuentros` NO es restringida —la decisión B eligió a propósito no esconderla, ver la clase
 * del servidor— así que `GET /api/discussions?filter[tag]=encuentros` le sigue respondiendo a
 * cualquiera, y quien quiera leer esos hilos por API puede. Lo que estas dos mitades garantizan
 * es que NINGÚN camino del producto lleve a un invitado al feed sin pedirle entrar antes. El día
 * que haga falta cerrarlo de verdad, la palanca es el permiso `tagN.viewForum` de la etiqueta,
 * que es ajuste de foro y no código.
 *
 * SE REDIRIGE AL SERVIDOR, no se pinta un estado propio: `window.location.assign` sale de la SPA
 * y deja que responda el middleware, de modo que la URL del muro y su `return` se construyen en
 * UN solo sitio. Un segundo copy de esa URL aquí es como se acaba con dos formatos de `return`.
 *
 * Y POR ESO MISMO, UN SOLO INTENTO. Si las dos mitades se desincronizan —el bundle desplegado y
 * el PHP no, o el middleware retirado— el servidor devolvería 200 a esa misma URL, la SPA
 * arrancaría, el guard volvería a saltar y el navegador quedaría dando vueltas sin que nadie
 * pudiera leer la página ni el error. La marca de un solo uso convierte ese fallo de despliegue
 * en «el muro no está puesto», que es visible y se arregla, en vez de en un bucle.
 *
 * `sessionStorage` y no una variable de módulo: la redirección es una carga completa, así que
 * cualquier estado en memoria se pierde justo en el viaje que hay que recordar. Envuelto en
 * `try/catch` porque en modo privado o con las cookies bloqueadas el acceso lanza — y entonces
 * lo correcto es no redirigir, no reventar la página.
 */
const ATTEMPT_KEY = 'umbral.comunidad.meetupsWallAttempt';

export default function guardMeetupsFeed() {
  extend(IndexPage.prototype, 'oncreate', function () {
    const onFeed = currentPath() === app.route('tag', { tags: MEETUPS_TAG_SLUG });

    if (app.session.user || !onFeed) {
      // Fuera del feed (o con sesión) la marca deja de tener sentido: se limpia para que el
      // próximo invitado que llegue aquí tenga su intento entero.
      try {
        window.sessionStorage.removeItem(ATTEMPT_KEY);
      } catch (e) {
        /* almacenamiento no disponible: no hay marca que limpiar */
      }

      return;
    }

    try {
      if (window.sessionStorage.getItem(ATTEMPT_KEY)) return;
      window.sessionStorage.setItem(ATTEMPT_KEY, '1');
    } catch (e) {
      return;
    }

    window.location.assign(app.forum.attribute('baseUrl') + '/t/' + MEETUPS_TAG_SLUG);
  });
}
